// Desktop-launch query params: when the SPA is opened from the desktop wrapper
// with ?deviceId=&clientId=&app=desktop, capture those values once at boot and
// inject them into the two auth payloads (User/login, User/selectLgnRegMethod).
// Cleared only after a successful auth response (see clearDesktopParams).

const DESKTOP_PARAMS_KEY = "desktopLaunchParams";

// Read the launch URL; persist the desktop params only if present. Safe on
// every boot — empty/absent params store nothing, so normal (non-desktop)
// launches leave existing parameter passing completely untouched.
export function captureDesktopParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    const clientId = (params.get("clientId") || "").trim();
    const deviceId = (params.get("deviceId") || "").trim();
    const app = (params.get("app") || "").trim();

    const captured = {};
    if (clientId) captured.ClientId = clientId;
    if (deviceId) captured.DeviceID = deviceId;
    if (app) captured.RequestFrom = app;

    if (Object.keys(captured).length > 0) {
      localStorage.setItem(DESKTOP_PARAMS_KEY, JSON.stringify(captured));
    }
  } catch (err) {
    console.error("captureDesktopParams failed:", err);
  }
}

// Return the stored desktop params object, or null if none/invalid.
export function getDesktopParams() {
  try {
    const raw = localStorage.getItem(DESKTOP_PARAMS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

// Override ClientId/DeviceID/RequestFrom on an outgoing payload with the
// captured values (only the captured keys). No-op when the app wasn't launched
// with desktop params. Does NOT clear storage — clearing happens via
// clearDesktopParams() after a successful auth response.
export function applyDesktopParams(requestParams) {
  const stored = getDesktopParams();
  if (stored) {
    Object.assign(requestParams, stored);
  }
  return requestParams;
}

// Remove the stored desktop params. Call after a successful auth response.
export function clearDesktopParams() {
  try {
    localStorage.removeItem(DESKTOP_PARAMS_KEY);
  } catch (err) {
    console.error("clearDesktopParams failed:", err);
  }
}
